// Airport dial styles
// H2 used for arrow text
// p used for dial numbers and data
// h4 used for dial data labels

interface TextStyles {
    compact: {
        h4: string;
        p: string;
        h2: string;
        iconSize: number;
    };
    cozy: {
        h4: string;
        p: string;
        h2: string;
        iconSize: number;
    };
}

export const TextStyles: TextStyles = {
    compact: {
        h4: `
			 font-family : Open Sans;
			 font-size : 12px;
			 font-style : normal;
			 font-weight : 700;
			 line-height : 18px; /* 150% */
			 letter-spacing : 0.4px;
		`,
        p: `
			 font-family : Open Sans;
			 font-size : 14px;
			 font-style : normal;
			 font-weight : 400;
			 line-height : 20px;
		`,
        h2: `
			 font-family : Open Sans;
			 font-size: 14px;
			 font-style: normal;
			 font-weight: 700;
			 line-height: 22px; /* 137.5% */
		`,
        iconSize: 24,
    },
    cozy: {
        h4: `
			font-family : Open Sans;
			font-size: 20px;
			font-style: normal;
			font-weight: 700;
			line-height: 26px; /* 130% */
		`,
        p: `
			font-family: Open Sans ;
			font-size : 20px;
			font-style :  normal ;
			font-weight : 400;
			line-height: 30px; /* 150% */
		`,
        h2: `
			font-family :  Open Sans ;
			font-size: 28px;
			font-style: normal;
			font-weight: 700;
			line-height: 30px; /* 107.143% */
		`,
        iconSize: 26,
    },
};
